import 'css-chunksrc/client/common/weekCalendar/years/styles.scss';export default {
  "calendar": "_calendar_ogj69_1",
  "heading": "_heading_ogj69_7",
  "title": "_title_ogj69_18",
  "iconBox": "_iconBox_ogj69_27",
  "disabledIconBox": "_disabledIconBox_ogj69_41",
  "icon": "_icon_ogj69_27",
  "rightIcon": "_rightIcon_ogj69_58",
  "leftIcon": "_leftIcon_ogj69_62",
  "main": "_main_ogj69_66",
  "years": "_years_ogj69_70",
  "row": "_row_ogj69_75",
  "year": "_year_ogj69_70",
  "selected": "_selected_ogj69_102",
  "clear": "_clear_ogj69_113",
  "button": "_button_ogj69_125"
};